import { BucketedReward } from '../../models/paymentSubmissions';
import getBucketedRewards from '../../services/bucketRewards/getBucketedRewards';

export const getAllReclaimRewards = async (): Promise<BucketedReward[]> => {
  try {
    return await getBucketedRewards();
  } catch (err) {
    return [];
  }
};
